<template>
  <TText variant="semibold" color="gray400" size="sm" classes="uppercase mb-2">
    {{ t(section.title) }}
  </TText>
  <ul class="mb-8 flex flex-col xl:mb-0 xl:flex-row">
    <li
      v-for="(item, item_index) in section.links"
      :key="item_index"
      class="pb-2 xl:mr-2"
      :class="[isIosIcon(item.icon) ? 'ios-show' : 'not-ios-show']"
    >
      <a
        :href="item.href"
        :rel="item.rel"
        :target="item.target"
        :aria-label="item.name"
      >
        <component :is="item.icon" aria-hidden="true" />
      </a>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { MenuLinkLink } from '../entities/Menu'

export type AppsIcon =
  | 'GooglePlayBadgeEs'
  | 'AppStoreBadgeEs'
  | 'GooglePlayBadgePt'
  | 'AppStoreBadgePt'

export type FooterMenuLink = MenuLinkLink & {
  id: string
  icon: AppsIcon
}
export type FooterMenu = Array<FooterMenuLink>

export type MenuFooterAppsSection = {
  title: string
  links: FooterMenu
}

interface MenuFooterAppsSection_Props {
  section: MenuFooterAppsSection
}

defineProps<MenuFooterAppsSection_Props>()

const isIosIcon = (icon: AppsIcon) =>
  icon === 'AppStoreBadgeEs' || icon === 'AppStoreBadgePt'
</script>

<style>
/* Filter Mobile Touch devices */
@media (hover: none) and (pointer: coarse) {
  .ios-show {
    display: none;
  }
  .not-ios-show {
    display: none;
  }

  /* Filter iOS devices */
  @supports (-webkit-overflow-scrolling: touch) {
    .ios-show {
      display: block;
    }
  }

  /* Filter NOT iOS devices */
  @supports not (-webkit-overflow-scrolling: touch) {
    .not-ios-show {
      display: block;
    }
  }
}
</style>
